const actions = {
  GET_FEATURES_CATEGORY_BEGIN: 'GET_FEATURES_CATEGORY_BEGIN',
  GET_FEATURES_CATEGORY_SUCCESS: 'GET_FEATURES_CATEGORY_SUCCESS',
  GET_FEATURES_CATEGORY_FAILED: 'GET_FEATURES_CATEGORY_FAILED',

  ADD_FEATURES_CATEGORY_BEGIN: 'ADD_FEATURES_CATEGORY_BEGIN',
  ADD_FEATURES_CATEGORY_SUCCESS: 'ADD_FEATURES_CATEGORY_SUCCESS',
  ADD_FEATURES_CATEGORY_FAILED: 'ADD_FEATURES_CATEGORY_FAILED',

  UPDATE_FEATURES_CATEGORY_BEGIN: 'UPDATE_FEATURES_CATEGORY_BEGIN',
  UPDATE_FEATURES_CATEGORY_SUCCESS: 'UPDATE_FEATURES_CATEGORY_SUCCESS',
  UPDATE_FEATURES_CATEGORY_FAILED: 'UPDATE_FEATURES_CATEGORY_FAILED',

  DELETE_FEATURES_CATEGORY_BEGIN: 'DELETE_FEATURES_CATEGORY_BEGIN',
  DELETE_FEATURES_CATEGORY_SUCCESS: 'DELETE_FEATURES_CATEGORY_SUCCESS',
  DELETE_FEATURES_CATEGORY_FAILED: 'DELETE_FEATURES_CATEGORY_FAILED',

  ADD_FEATURES_BEGIN: 'ADD_FEATURES_BEGIN',
  ADD_FEATURES_SUCCESS: 'ADD_FEATURES_SUCCESS',
  ADD_FEATURES_FAILED: 'ADD_FEATURES_FAILED',

  UPDATE_FEATURES_BEGIN: 'UPDATE_FEATURES_BEGIN',
  UPDATE_FEATURES_SUCCESS: 'UPDATE_FEATURES_SUCCESS',
  UPDATE_FEATURES_FAILED: 'UPDATE_FEATURES_FAILED',

  DELETE_FEATURES_BEGIN: 'DELETE_FEATURES_BEGIN',
  DELETE_FEATURES_SUCCESS: 'DELETE_FEATURES_SUCCESS',
  DELETE_FEATURES_FAILED: 'DELETE_FEATURES_FAILED',

  getFeaturesCategoryBegin: () => {
    return {
      type: actions.GET_FEATURES_CATEGORY_BEGIN,
    };
  },

  getFeaturesCategorySuccess: data => {
    return {
      type: actions.GET_FEATURES_CATEGORY_SUCCESS,
      data,
    };
  },

  getFeaturesCategoryFailed: err => {
    return {
      type: actions.GET_FEATURES_CATEGORY_FAILED,
      err,
    };
  },

  addFeaturesCategoryBegin: () => {
    return {
      type: actions.ADD_FEATURES_CATEGORY_BEGIN,
    };
  },

  addFeaturesCategorySuccess: data => {
    return {
      type: actions.ADD_FEATURES_CATEGORY_SUCCESS,
      data,
    };
  },

  addFeaturesCategoryFailed: err => {
    return {
      type: actions.ADD_FEATURES_CATEGORY_FAILED,
      err,
    };
  },
  addFeaturesBegin: () => {
    return {
      type: actions.ADD_FEATURES_BEGIN,
    };
  },

  addFeaturesSuccess: data => {
    return {
      type: actions.ADD_FEATURES_SUCCESS,
      data,
    };
  },

  addFeaturesFailed: err => {
    return {
      type: actions.ADD_FEATURES_FAILED,
      err,
    };
  },
  updateFeaturesCategoryBegin: () => {
    return {
      type: actions.UPDATE_FEATURES_CATEGORY_BEGIN,
    };
  },

  updateFeaturesCategorySuccess: data => {
    return {
      type: actions.UPDATE_FEATURES_CATEGORY_SUCCESS,
      data,
    };
  },

  updateFeaturesCategoryFailed: err => {
    return {
      type: actions.UPDATE_FEATURES_CATEGORY_FAILED,
      err,
    };
  },
  updateFeaturesBegin: () => {
    return {
      type: actions.UPDATE_FEATURES_BEGIN,
    };
  },

  updateFeaturesSuccess: data => {
    return {
      type: actions.UPDATE_FEATURES_SUCCESS,
      data,
    };
  },

  updateFeaturesFailed: err => {
    return {
      type: actions.UPDATE_FEATURES_FAILED,
      err,
    };
  },
  deleteFeaturesCategoryBegin: () => {
    return {
      type: actions.DELETE_FEATURES_CATEGORY_BEGIN,
    };
  },

  deleteFeaturesCategorySuccess: data => {
    return {
      type: actions.DELETE_FEATURES_CATEGORY_SUCCESS,
      data,
    };
  },

  deleteFeaturesCategoryFailed: err => {
    return {
      type: actions.DELETE_FEATURES_CATEGORY_FAILED,
      err,
    };
  },
  deleteFeaturesBegin: () => {
    return {
      type: actions.DELETE_FEATURES_BEGIN,
    };
  },

  deleteFeaturesSuccess: data => {
    return {
      type: actions.DELETE_FEATURES_SUCCESS,
      data,
    };
  },

  deleteFeaturesFailed: err => {
    return {
      type: actions.DELETE_FEATURES_FAILED,
      err,
    };
  },
};

export default actions;
